import { req,reqfile } from './axiosFun';

/**
 * 其他管理
 **/
// 提交WebSocket消息
export const submitWebsocketMessage = (params) => { 
    return req("post", "/apiOther/other/mqtt/send", params) 
};

// 下载历史数据
export const downloadData = (params) => { 
    return reqfile("post", "/apiOther/other/mqtt/downloadFile", params) 
};


// WEBPACK FOOTER //
// ./src/api/otherMG.js